import { useState } from "react";
import { Plus, X } from "lucide-react";

// Varios nombres (compositores, productores…): uno por uno, con botón "+".
// Se guarda igual que antes ("Nombre 1, Nombre 2") para no cambiar nada en el backend.
const split = (v) => String(v || "").split(",").map((x) => x.trim()).filter(Boolean);

export default function NameListInput({ value, onChange, placeholder, testId }) {
  const names = split(value);
  const [draft, setDraft] = useState("");
  const add = () => {
    const parts = split(draft);
    if (!parts.length) return;
    const next = [...names];
    parts.forEach((p) => { if (!next.some((n) => n.toLowerCase() === p.toLowerCase())) next.push(p.slice(0, 120)); });
    onChange(next.join(", "));
    setDraft("");
  };
  const remove = (i) => onChange(names.filter((_, j) => j !== i).join(", "));
  return (
    <div className="rounded-lg border border-slate-300 bg-white p-1.5 focus-within:border-black" data-testid={testId}>
      {names.length > 0 && (
        <div className="mb-1 flex flex-wrap gap-1">
          {names.map((n, i) => (
            <span key={`${n}-${i}`} className="inline-flex items-center gap-1 rounded-full bg-slate-100 px-2 py-0.5 text-xs text-slate-800">
              {n}<button type="button" onClick={() => remove(i)} className="text-slate-400 hover:text-red-500" aria-label={`Quitar ${n}`}><X className="h-3 w-3" /></button>
            </span>
          ))}
        </div>
      )}
      <div className="flex items-center gap-1">
        <input value={draft} onChange={(e) => setDraft(e.target.value)} onBlur={add}
          onKeyDown={(e) => { if (e.key === "Enter" || e.key === ",") { e.preventDefault(); add(); } }}
          placeholder={names.length ? "Agregar otro…" : placeholder} className="min-w-0 flex-1 bg-transparent px-1.5 py-1 text-xs outline-none" data-testid={`${testId}-input`} />
        <button type="button" onClick={add} disabled={!draft.trim()} className="rounded-md p-1 text-slate-500 hover:bg-slate-100 hover:text-black disabled:opacity-30" title="Agregar"><Plus className="h-4 w-4" /></button>
      </div>
    </div>
  );
}
